// ========================================================
// ATELIER — ATUALIZA A BOLHA NATIVA DO CARRINHO
// ========================================================

function updateCartCount(cart) {

  if (!cart) return;

  const count = Number(cart.item_count || 0);

  document
    .querySelectorAll('cart-icon')
    .forEach(cartIcon => {

      const bubble =
        cartIcon.querySelector(
          '.cart-bubble'
        );

      const countElement =
        cartIcon.querySelector(
          '.cart-bubble__text-count'
        );

      if (!bubble || !countElement) {
        return;
      }


      // ----------------------------------------
      // ATUALIZA O NÚMERO
      // ----------------------------------------

      countElement.textContent =
        count < 100
          ? String(count)
          : '99+';


      // ----------------------------------------
      // CARRINHO COM ITENS
      // ----------------------------------------

      if (count > 0) {

        bubble.classList.remove(
          'visually-hidden'
        );

        countElement.classList.remove(
          'hidden'
        );

        cartIcon.classList.add(
          'header-actions__cart-icon--has-cart'
        );

        bubble.removeAttribute(
          'aria-hidden'
        );

        countElement.setAttribute(
          'aria-hidden',
          'true'
        );


        if (count <= 99) {

          bubble.setAttribute(
            'data-maintain-ratio',
            ''
          );

        } else {

          bubble.removeAttribute(
            'data-maintain-ratio'
          );

        }

      }


      // ----------------------------------------
      // CARRINHO VAZIO
      // ----------------------------------------

      else {

        bubble.classList.add(
          'visually-hidden'
        );

        countElement.classList.add(
          'hidden'
        );

        cartIcon.classList.remove(
          'header-actions__cart-icon--has-cart'
        );

      }


      // ----------------------------------------
      // ANIMAÇÃO NATIVA DA BOLHA
      // ----------------------------------------

      bubble.classList.remove(
        'cart-bubble--animating'
      );


      void bubble.offsetWidth;


      bubble.classList.add(
        'cart-bubble--animating'
      );


      window.setTimeout(
        () => {

          bubble.classList.remove(
            'cart-bubble--animating'
          );

        },
        600
      );

    });


  // ======================================================
  // CONTADOR QUE APARECE DENTRO DO DRAWER
  // ======================================================

  document
    .querySelectorAll(
      '.theme-drawer__badge'
    )
    .forEach(badge => {

      badge.textContent =
        String(count);


      if (count > 0) {

        badge.classList.remove(
          'visually-hidden'
        );

      } else {

        badge.classList.add(
          'visually-hidden'
        );

      }

    });


  console.log(
    '[AtelierBridge] carrinho:',
    count
  );

}